import { Col, Row } from 'react-bootstrap';
import RadioInput from '../common/radio';

const ForcePassword = ({ values, setFieldValue }) => {
  return (
    <Row className="open-enrollment-approval Payment-details section-separator-border">
      <Col md={5} lg={5} sm={5} className="padding-0">
        <h3>Force Password Reset After Unlock</h3>
        <p>
          Select whether Password reset is required after account has been
          unlocked.
        </p>
      </Col>
      <Col md={2} lg={2} sm={2} className="setup-form">
        <Row className="pt-2">
          <Col>
            <RadioInput
              id="enable-force-password"
              label="Yes"
              name="ForcePassword"
              value={true}
              checked={values.ForcePassword === true}
              onChange={(e) => {
                setFieldValue('ForcePassword', true);
              }}
            />
          </Col>
          <Col className="approval-enroll">
            <RadioInput
              id="disable-force-password"
              label="No"
              name="ForcePassword"
              value="no"
              checked={values.ForcePassword === false}
              onChange={(e) => {
                setFieldValue('ForcePassword', false);
              }}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default ForcePassword;
